<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-profile-sidebar w-full sm:w-25rem">
    <div class="flex flex-column mx-auto md:mx-0">
        <span class="mb-2 font-semibold"></span>
        <span class="text-color-secondary font-medium mb-5"></span>
        <div *ngIf="hayImpersonacion()" class="mb-3 text-xs text-red-400 text-center">
            <i class="pi pi-user mr-1"></i> Estás logeado como <strong>{{ nombreEmpleadoActual }}</strong>
        </div>
        
        <ul class="list-none m-0 p-0">
            <li (click)="perfil()">
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-user text-xl text-primary"></i>
                    </span>
                    <div class="ml-3">
                        <span class="mb-2 font-semibold">Perfil</span>
                        <p class="text-color-secondary m-0"></p>
                    </div>
                </a>
            </li>
        
            <!-- 🔵 Nuevo botón SOLO si es admin -->
            <li *ngIf="isAdmin" (click)="abrirLoginAs()">
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-user-plus text-xl text-primary"></i>
                    </span>
                    <div class="ml-3">
                        <span class="mb-2 font-semibold">Login As</span>
                        <p class="text-color-secondary m-0">Simular como otro usuario</p>
                    </div>
                </a>
            </li>
            <li *ngIf="hayImpersonacion()" (click)="volverAMiPerfilOriginal()">
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-refresh text-xl text-primary"></i>
                    </span>
                    <div class="ml-3">
                        <span class="mb-2 font-semibold">Volver a Mi Perfil</span>
                        <p class="text-color-secondary m-0">Salir de Login As</p>
                    </div>
                </a>
            </li>
            
        
            <li (click)="logOut()">
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-power-off text-xl text-primary"></i>
                    </span>
                    <div class="ml-3">
                        <span class="mb-2 font-semibold">Desconectar</span>
                        <p class="text-color-secondary m-0"></p>
                    </div>
                </a>
            </li>
        </ul>
        
    </div>

    <p-dialog [(visible)]="loginAsDialogVisible" [modal]="true" [style]="{width: '30vw'}" [closable]="true">
        <ng-template pTemplate="header">
            <h4>Seleccionar Empleado</h4>
        </ng-template>
    
        <ng-template pTemplate="content">
            <p-autoComplete
            [(ngModel)]="selectedEmpleado"
            [suggestions]="filteredEmpleados"
            (completeMethod)="filtrarEmpleados($event)"
            field="fullName"
            [forceSelection]="true"
            [dropdown]="true"
            [appendTo]="'body'"
            optionLabel="fullName"
            [emptyMessage]="'No se encontraron empleados'"
            placeholder="Buscar empleado">
        </p-autoComplete>
        
        
        
        </ng-template>
    
        <ng-template pTemplate="footer">
            <p-button label="Impersonar" (onClick)="confirmarLoginAs()" [disabled]="!selectedEmpleado?.EMPLEADO_ID"></p-button>
        </ng-template>
    </p-dialog>
    

</p-sidebar>